import { IconNames } from "@blueprintjs/icons";
import { default as Autobind } from "autobind-decorator";
import React from "react";

import { Button, ControlGroup } from "@blueprintjs/core";
import IOption from "common/models/IOption";
import { iDefL } from "core/util/TypeUtils";
import BaseWidget from "./BaseWidget";
import ColorPickerWidget from "./ColorPickerWidget";
import DirectionWidget from "./DirectionWidget";

enum Directions {
	UP = "to top",
	RIGHT = "to right",
	DOWN = "to bottom",
	LEFT = "to left"
}

interface IGradient {
	direction: string;
	values: string[];
}

export default class LinearGradientWidget extends BaseWidget<IGradient, string> {

	public render() {
		const gradient = this.fromValue(this.props.value);

		return (
			<ControlGroup fill={true} vertical={true}>
				<DirectionWidget
					autofocus={false}
					onChange={(value) => this.onChange(gradient, value, "direction")}
					options={undefined}
					readonly={false}
					value={gradient.direction}
				/>
				{
					gradient.values.map((v, i) => {
						return (
							<div key={i}>
								<Button
									minimal={true}
									icon={IconNames.REMOVE}
									onClick={() => this.removeValue(gradient, i)}
								/>
								<ColorPickerWidget
									autofocus={false}
									key={i}
									onChange={(val) => this.editValue(gradient, i, val)}
									options={undefined}
									readonly={false}
									value={v}
								/>
							</div>
						);
					})
				}
				{
					gradient.values.length < 8 && (
						<Button
							icon={IconNames.ADD}
							minimal={true}
							onClick={() => this.addValue(gradient)}
							text="Add Gradient Step"
						/>
					)
				}
			</ControlGroup>
		);
	}

	@Autobind
	public onChange(gradient: IGradient, value: string | string[], part: string) {
		const nextValue: string = this.toValue({...gradient, [part]: value});
		this.props.onChange(nextValue);
	}

	@Autobind
	protected toValue(gradient: IGradient): string {
		const { direction, values } = gradient;
		const nextValue: string = [direction, ...values].join(',');
		return nextValue;
	}

	@Autobind
	protected fromValue(value: string): IGradient {
		const vals: string[] = value.split(/(?:,(?=#)|,(?=r))+/);

		const nextValue = {
			direction: vals[0],
			values: vals.slice(1).map((v) => {
				// this is dumb, will fix this later
				if (v.indexOf("rgb") > -1 && v.slice(v.length - 1) !== ")") {
					return `${v})`;
				} else {
					return v;
				}
			})
		};

		return nextValue;
	}

	@Autobind
	private addValue(gradient: IGradient) {
		const nextValues = [ ...gradient.values ];
		nextValues.push("rgba(255,255,255,1)");
		this.onChange(gradient, nextValues, "values");
	}

	@Autobind
	private removeValue(gradient: IGradient, index: number) {
		this.onChange(gradient, gradient.values.filter((v, i) => i !== index), "values");
	}

	@Autobind
	private editValue(gradient: IGradient, index: number, value: string) {
		this.onChange(gradient, gradient.values.map((v, i) => i === index ? value : v), "values");
	}

}



// WEBPACK FOOTER //
// ./src/common/form/widgets/LinearGradientWidget.tsx